export default "__VITE_ASSET__D9hIDu8q__"